if (!customElements.get('gi-grid-banner-video')) {
  class GiGridBannerVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playbackButton = this.querySelector('.gi-grid-banner__playback-button');
      this.soundButton = this.querySelector('.gi-grid-banner__sound-button');
      if (!this.video || !this.playbackButton) return;

      this.forcePaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.video.addEventListener('play', () => this.updateState());
      this.video.addEventListener('pause', () => this.updateState());
      this.video.addEventListener('volumechange', () => this.updateState());
      this.playbackButton.addEventListener('click', () => this.togglePlayback());
      this.soundButton?.addEventListener('click', () => (this.video.muted = !this.video.muted));

      // Play only while visible, so off-screen banners don't keep decoding video.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.forcePaused) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);

      this.updateState();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    togglePlayback() {
      if (this.video.paused) {
        this.forcePaused = false;
        this.video.play().catch(() => {});
      } else {
        this.forcePaused = true;
        this.video.pause();
      }
    }

    updateState() {
      const playing = !this.video.paused;
      this.classList.toggle('is-playing', playing);
      this.playbackButton.setAttribute(
        'aria-label',
        playing ? this.playbackButton.dataset.labelPause : this.playbackButton.dataset.labelPlay
      );

      this.classList.toggle('is-muted', this.video.muted);
      this.soundButton?.setAttribute(
        'aria-label',
        this.video.muted ? this.soundButton.dataset.labelUnmute : this.soundButton.dataset.labelMute
      );
    }
  }

  customElements.define('gi-grid-banner-video', GiGridBannerVideo);
}

if (!customElements.get('gi-shop-the-look')) {
  class GiShopTheLook extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.gi-shop-the-look__dialog');
      this.openButton = this.querySelector('.gi-shop-the-look__open-button');
      if (!this.dialog || !this.openButton) return;

      this.openButton.addEventListener('click', () => this.open());
      this.querySelector('.gi-shop-the-look__close-button').addEventListener('click', () => this.dialog.close());

      // A click on the dialog element itself lands on its backdrop, the panel covers the rest.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // Make way for the cart drawer opening after a product is added from the panel.
      if (typeof subscribe === 'function') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          if (this.dialog.open) this.dialog.close();
        });
      }
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
      this.swiper?.destroy();
    }

    open() {
      this.dialog.showModal();

      // Swiper measures the slides, so it starts once the panel is displayed.
      if (!this.swiper && typeof Swiper === 'function') {
        this.swiper = new Swiper(this.querySelector('.gi-shop-the-look__swiper'), {
          slidesPerView: 2.2,
          spaceBetween: 16,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('.gi-shop-the-look__navigation-button--prev'),
            nextEl: this.querySelector('.gi-shop-the-look__navigation-button--next'),
          },
          breakpoints: {
            750: {
              slidesPerView: 3,
              slidesOffsetBefore: 40,
              slidesOffsetAfter: 40,
            },
            1025: {
              slidesPerView: 4,
              slidesOffsetBefore: 40,
              slidesOffsetAfter: 40,
            },
            1440: {
              slidesPerView: 6,
              slidesOffsetBefore: 40,
              slidesOffsetAfter: 40,
            },
          },
        });
      }
    }
  }

  customElements.define('gi-shop-the-look', GiShopTheLook);
}
